/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Agent_Builder_Max_Steps_Over_Org_LimitInputs */



/**
* | output |
* | --- |
* | "Your organization allows at most {max} actions per run." |
*
* @param {Agent_Builder_Max_Steps_Over_Org_LimitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_over_org_limit = /** @type {((inputs: Agent_Builder_Max_Steps_Over_Org_LimitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_Over_Org_LimitInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre Organisation erlaubt höchstens ${i?.max} Aktionen pro Lauf.`)
	return /** @type {LocalizedString} */ (`Your organization allows at most ${i?.max} actions per run.`)
});